import { baseColors } from '../default';
import { defaultLightTheme } from '../default/default';
const b2bBackground = '#002FA7';
export const b2bTheme = {
    ...defaultLightTheme,
    color: {
        ...defaultLightTheme.color,
        button: {
            ...defaultLightTheme.color.button,
            primary: {
                ...defaultLightTheme.color.button.primary,
                fill: {
                    on: {
                        background: baseColors.blue.darkest,
                    },
                },
                border: {
                    on: {
                        background: baseColors.blue.darkest,
                    },
                },
                hover: {
                    ...defaultLightTheme.color.button.primary.hover,
                    fill: {
                        on: {
                            background: baseColors.blue.darker,
                        },
                    },
                    border: {
                        on: {
                            background: baseColors.blue.darker,
                        },
                    },
                },
            },
        },
        fill: {
            ...defaultLightTheme.color.fill,
            strong: b2bBackground,
        },
    },
    name: 'b2b',
};
//# sourceMappingURL=index.js.map